import {AbstractEvent} from "@/modules/base/events";
import {DivisionPromotion, KODivision} from "@/modules/competitions/entity";
import {Team} from "@/modules/team/entity";

export class AfterCupPromotionEvent extends AbstractEvent {
  constructor(
    public team: Team,
    public from: KODivision,
    public promotion: DivisionPromotion,
  ) {
    super();
  }
}